import {Table } from 'antd'
import React, { useEffect, useState } from 'react'
import LoanEdit from './LoanEdit';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './loan.module.css';
import StateTag from '../../cpn/StateTag';
function LoanListPendding(props) {
    const [list,setList] = useState([]);   
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => item.jk_state === '1' && item.jk_uid === props.yh_id);            
            arr.sort((a, b) => new Date(b.jk_ctime) - new Date(a.jk_ctime));
             // Ensure each item has a unique key property
             arr = arr.map((item) => ({
                ...item,
                key: item.key || item.jk_id
            }));
            setList(arr);
        }
    }, [props.list, props.yh_id])
    
    const columns = [    
        {
            title: '借款人',
            dataIndex: 'jk_kh_name',
            width: '12%',
            key: 'jk_kh_name',         
            render: (text, record) => <LoanEdit 
                                        jk_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        jk_bzd_id={record.jk_bzd_id}
                                        jk_price={record.jk_price}
                                        jk_content={record.jk_content}
                                        jk_date={record.jk_date}
                                        jk_date_end={record.jk_date_end}
                                        jk_bzd_name={record.jk_bzd_name}
                                        jk_bzd_danhao={record.jk_bzd_danhao}
                                        jk_type_id={record.jk_type_id}
                                        jk_type_name={record.jk_type_name}
                                        jk_kh_id={record.jk_kh_id}
                                        jk_kh_name={record.jk_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        jk_num={record.jk_num}
                                        jk_amount={record.jk_amount}
                                        jk_state={record.jk_state}
                                        jk_bm_id={record.jk_bm_id}
                                        jk_bm_name={record.jk_bm_name}
                                        jk_khyhzh_id={record.jk_khyhzh_id}
                                        jk_khyhzh_name={record.jk_khyhzh_name}
                                        jk_image_name={record.jk_image_name}
                                        jk_image_file={record.jk_image_file}
                                        jk_ctime={record.jk_ctime}
                                    />
        },
        {
            title: '借款金额',
            dataIndex: 'jk_amount',
            width: '10%',
            key: 'jk_amount',   
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'jk_content',
            key:'jk_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"jk_bzd_danhao",
            key:'jk_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.jk_bzd_name} dsbzd_id={record.jk_bzd_id} dsbzd_danhao={record.jk_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '状态',
            dataIndex: 'jk_state',
            width: '5%',
            key: 'jk_state',            
            render:(text) => <StateTag state={text} />
        },
        {
            title: '编号',
            dataIndex: 'key',
            width: '10%',
            key: 'key',            
        },
        
    ]
    return (
        <>                            
            {/* <Flex style={{ marginBottom: "10px" }} justify='space-between' align='center'>
                <Form 
                    name='income' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        console.log(values,'values');
                        setQuery(prev => ({
                            ...prev, 
                            jk_content: values.jk_content ? values.jk_content : '', 
                            jk_kh_id: values.jk_kh_id ? values.jk_kh_id : '',
                            jk_bzd_danhao: values.jk_bzd_danhao ? values.jk_bzd_danhao : '',
                        }))
                    }}
                    initialValues={{
                        jk_content:'',
                        jk_kh_id:'',
                        jk_bzd_danhao:'',
                    }}
                >
                    <Form.Item name='jk_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            style={{width:'150px'}}
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name='jk_bzd_danhao'>
                        <Input 
                            placeholder='团队编号' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item name='jk_content'>
                        <Input 
                            placeholder='备注关键字' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({
                                        jk_content:''
                                    })
                                }}
                            />                          
                        </Space>
                    </Form.Item>
                </Form>
            </Flex> */}
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1}>
                                <span style={{color:'#660099'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无借款单' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default LoanListPendding